const constants = {
  AUTO_FEES_BREAKDOWN_TITLE: "Automatic Fees Breakdown",
  AUTO_FEES_BREAKDOWN_DETAILS:
    "When this setting is enabled, any payment made will be automatically distributed across the fee items (e.g., Tuition Fees and Feeding Fees) in the order they were added, with the first item being prioritized. If the setting is disabled, users will manually select which fee items to apply the payment to.",
};

export default constants;
